import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { DocumentsList } from '@widgets/documentsList';
export function DocumentsPage() {
    return (_jsx(_Fragment, { children: _jsx(DocumentsList, {}) }));
}
